import { createSelector } from 'reselect'
import { selectLocationState } from 'redux-first-router'
import { selectNewNoteDraftMailboxId } from 'ducks/drafts/selectors/noteDrafts'
import { selectAgentsSortedByUsername } from 'selectors/agents/base'
import { selectCurrentMailboxId } from 'selectors/mailboxes/selectCurrentMailboxId'
import { selectCurrentTicketUndecorated } from 'selectors/tickets/current/selectCurrentTicketUndecorated'
import { emptyObj } from 'util/objects'
import { createBasicSelector } from 'util/redux'

const emptyAccessList = { widget: {}, mailbox: {} }

const selectAccessLists = createBasicSelector(
  state => state.app.accessLists || emptyAccessList
)

export const selectMailboxAccessList = createBasicSelector(
  selectAccessLists,
  accessLists => accessLists.mailbox || emptyObj
)

export const selectWidgetAccessLists = createBasicSelector(
  selectAccessLists,
  accessLists => accessLists.widget || emptyObj
)

export const selectCurrentChannelAccessList = createBasicSelector(
  selectAccessLists,
  selectLocationState,
  selectCurrentTicketUndecorated,
  selectCurrentMailboxId,
  (accessLists, location, ticket, listMailboxId) => {
    if ((location?.query?.channelId || '').startsWith('wid_')) {
      return accessLists.widget[location.query.channelId]
    } else if (ticket?.mailboxId) {
      return accessLists.mailbox[ticket.mailboxId]
    }
    return listMailboxId
  }
)

const selectNewNoteDraftMailboxAccessList = createBasicSelector(
  selectAccessLists,
  selectNewNoteDraftMailboxId,
  (accessLists, mailboxId) => {
    if (!mailboxId) return null
    return accessLists.mailbox[mailboxId]
  }
)

export const selectCurrentMailboxAgents = createSelector(
  selectAgentsSortedByUsername,
  selectCurrentChannelAccessList,
  (agents, accessList) => {
    if (accessList && accessList.agentIds && accessList.agentIds.length > 0) {
      return agents.filter(agent => accessList.agentIds.indexOf(agent.id) > -1)
    }
    return agents
  }
)

export const selectNewNoteDraftMailboxAgents = createSelector(
  selectAgentsSortedByUsername,
  selectNewNoteDraftMailboxAccessList,
  (agents, accessList) => {
    if (accessList && accessList.agentIds && accessList.agentIds.length > 0) {
      return agents.filter(agent => accessList.agentIds.indexOf(agent.id) > -1)
    }
    return agents
  }
)
